<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="劃位資源管理"
      fkey="rvm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="col-6 rc-bar-view">
      <store-rc-view
        ref="rcView"
        :op_hours="op_hours"
        :cal_blocks="cal_blocks"
        :has_map="has_map"
        :block_clicked="block_clicked"
      ></store-rc-view>
    </div>
    <div class="col-6 rv-list-view">
      <div
        v-if="filter_time===''"
      >
        <span>本日全部劃位：{{day_reserves_all.length}}人次</span>
      </div>
      <div
        v-if="filter_time!==''"
      >
        <b-link @click="return_all">全部</b-link><span>當前{{filter_time}}劃位:{{day_reserves.length}}人次</span>
      </div>
      <b-table
        :fields="reserve_fields"
        :items="day_reserves" 
      >
        <template slot="reserve_user" slot-scope="row">
          <b-link @click="operateReserve(row.item)">{{row.item.reserve_user}}</b-link>
        </template>
      </b-table>
    </div>
    <b-modal
      id="addModal"
      ref="addModal"
      v-model="modalAddShow"
      :static="true"
      centered
      hide-header
      hide-footer
      @hide="closeCheck"
      @shown="setFocus"
    >
      <add-private-reserve
        ref="apr"
        :target_date="filterData.viewDate"
        :op_hours="op_hours"
        :minuteInterval="service_minute_unit"
        :filter_start_time="filter_time"
        :cancel_create="closeExtAdd"
        :successReload="successReload"
      ></add-private-reserve>
    </b-modal>
    <b-modal
      id="operateModal"
      ref="operateModal"
      v-model="modalOperateShow" 
      centered
      :static="true"
      size="lg"
      hide-header
      hide-footer
    >
      <reserve-operate-view
        ref="rov"
        :target_date="filterData.viewDate"
        :op_hours="op_hours"
        :minuteInterval="service_minute_unit"
        :cancel_create="closeExtOperate"
        :successReload="successReload"
      ></reserve-operate-view>
    </b-modal>

  </div>
</template>

<script>

import StoreRcView from "./SubComponent/StoreRcView"
import AddPrivateReserve from './SubComponent/AddPrivateReserve'
import ReserveOperateView from './SubComponent/ReserveOperateView'

export default {
  name: 'StoreRcManage',
  components:{
    StoreRcView,
    AddPrivateReserve,
    ReserveOperateView
  },
  props: {
    
  },
  data: function () {
    return {
      fromStack:[],
      fromParams:{},
      highlight_from:"",
      highlight_to:"",
      service_minute_unit:0,
      modalAddShow:false,
      modalOperateShow:false,
      editItem:{},
      filterOptions:[
        {
          componentType:'b-button',
          placeholder:'返回',
          col:2,
          hide:(!this.fromStack||this.fromStack.length===0),
          execCallback:this.goBack
        },
        {
          componentType:'span',
          col:10,
          hide:(!this.fromStack||this.fromStack.length===0),
        },
        {
          componentType:'date-picker',
          defaultValue:this.toISODateString(new Date()),
          akey:'viewDate',
          col:3,
          placeholder:'檢視日期',
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          col:9,
          buttons:[
            {
              akey:"btnAddCustomR",
              col:4,
              placeholder: "+自訂",
              execCallback: this.showExtAdd
            },
            {
              akey:"btnInvite",
              col:4,
              placeholder: "邀約劃位",
              execCallback: this.showInvite
            }
          ]
        },
      ],
      filterData:{},
      view_date:null,
      // res_map貌似不用存起來= =
      has_map:false,
      op_hours:[],
      cal_blocks:[],

      day_reserves_all:[],
      day_reserves:[],
      filter_time:'',
      reserve_fields:[
        {
          key:'reserve_start_time',
          label:'開始時間'
        },
        {
          key:'reserve_user',
          label:'劃位者'
        }
      ]
    }
  },
  methods: {
    goBack() {
      // 這個頁面目前設計得可能會被多種情境跳轉呼叫,所以要提供跳回去的機制
      this.$bus.linkCallStack = this.fromStack
      this.$bus.landingComponent = this.fromStack[this.fromStack.length-1].landingComponent
    },
    operateReserve(item) {
      this.$refs.rov.setData(item)
      this.modalOperateShow = true
    },
    showExtAdd() {
      if (this.op_hours.length === 0) {
        this.$bus.fnShowInfo('當前日期無法操作')
        return
      }
      this.$refs.apr.initDefault()
      this.modalAddShow = true
    },
    showInvite() {
      if (this.op_hours.length === 0) {
        this.$bus.fnShowInfo('當前日期無法操作')
        return
      }
      // this.modalInviteShow = true
    },
    closeExtAdd() {
      this.modalAddShow = false
    },
    closeExtOperate() {
      this.modalOperateShow = false
    },
    successReload(date) {
      // 看看popup上有無調整日期
      if (date !== undefined && date !== this.filterData.viewDate) {
        this.filterData.viewDate = date
        this.$refs.filterForm.refreshModelVar('viewDate')
      }
      this.get_date_data()
      this.modalAddShow = false
      this.modalOperateShow = false
      setTimeout(() => {
        this.$bus.fnShowInfo('已更新')
      }, 100);
    },
    filterChanged(upd) {
      this.get_date_data(upd)
    },
    closeCheck: function (evt) {
      if (this.modalAddShow) {
        evt.preventDefault()
      }
    },
    setFocus: function () {
      this.$refs.apr.$refs.addForm.setFocus('extSrcTypeId')
    },
    get_date_data() {
      let Param = {
        'module':'store',
        'method':'getStoreReserveViewOneDay',
        'date': this.filterData.viewDate,
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.day_reserves_all = vm.getSimpleReserve(data.data.day_reserves)
        vm.day_reserves = vm.day_reserves_all
        vm.processDateData(data.data.res_map)
      }, this)
    },
    block_clicked(block) {
      //alert("WOW!"+JSON.stringify(block))
      // 點擊左邊時段,用時段來filter右邊顯示的劃位
      this.day_reserves = []
      for (let i=0;i<this.day_reserves_all.length;i++) {
        if ((this.day_reserves_all[i].data.reserve_end_time > block.start_time &&
              this.day_reserves_all[i].data.reserve_start_time < block.end_time
          )) 
        {
          this.day_reserves.push(this.day_reserves_all[i])
        }
      }
      this.filter_time = this.getPartFromDatetimeStr(block.start_time,'hourminute')
    },
    return_all() {
      this.filter_time = ''
      this.day_reserves = this.CpObj(this.day_reserves_all)
    },
    getSimpleReserve(day_reserves) {
      let simple = []
      for (let i=0; i<day_reserves.length;i++) {
        simple.push({
          reserve_start_time:this.getPartFromDatetimeStr(day_reserves[i].reserve_start_time,'hourminute'),
          reserve_user:(day_reserves[i].reserve_type==='external_reserve'?('(外)'+day_reserves[i].reserve_user+day_reserves[i].reserve_remark):day_reserves[i].reserve_user),
          data:day_reserves[i]
        })
      }
      return simple
    },
    processDateData(res_map) {
      let start_hour = 8
      let end_hour = 20
      let start_key = null
      let last_key = null
      let datehour = null
      let prev_end_time = null
      // 計算右邊時段時間是幾分鐘
      let dt1 = null
      let dt2 = null
      this.op_hours = []
      this.cal_blocks = []
      // 因為是測試自己抓api而非由prop傳入所以需要setTimeout克服時間差
      for (let time_key in res_map) {
        if (!start_key) {
          start_hour = this.getPartFromDatetimeStr(time_key)
          start_key = time_key
        }
        last_key = time_key
      }
      if (start_key) {
        this.has_map = true
      }
      else {
        this.has_map = false
      }
      if (!this.has_map) {
        return
      }
      // end_hour這樣就對了不用再判斷調整(因為是"開始"時間且時段至少有一分鐘且當前時段皆不超過一小時)
      end_hour = this.getPartFromDatetimeStr(last_key)
      // 最複雜的處理在這裡做
      for (let i=start_hour; i<= end_hour; i++) {
        this.op_hours.push({
          hour:i,
          text:((i<10?'0':'')+i)
        })
      }
      datehour = this.getPartFromDatetimeStr(start_key, 'datehour')
      // 接著是複雜的右邊時段
      //第一個時段由start_key是否是整點判斷
      if (this.getPartFromDatetimeStr(start_key, 'minute') > 0) {
        this.cal_blocks.push({
          id:0,
          start_time: datehour,
          end_time: start_key,
          duration:this.getPartFromDatetimeStr(start_key, 'minute'),
          overlays:0,
          auto_accept_count:0
        })
      }
      for (let time_key in res_map) {
        let is_highlight_start = false
        let is_highlighted = false
        let is_highlight_end = false
        if (this.highlight_from && time_key === this.highlight_from) {
          is_highlight_start = true
        }
        if (this.highlight_from && this.highlight_to && time_key >= this.highlight_from && res_map[time_key].end_time <= this.highlight_to) {
          is_highlighted = true
        }
        if (res_map[time_key].end_time === this.highlight_to) {
          is_highlight_end = true
        }
        // 正常情況都是連續的,只有被休息時段截掉才會不連續,此時要額外產生一個時段
        if (time_key !== prev_end_time && prev_end_time !== null) {
          dt1 = this.getTimestampFromDatetimeStr(prev_end_time)
          dt2 = this.getTimestampFromDatetimeStr(time_key)
          this.cal_blocks.push({
            id:0,
            start_time: prev_end_time,
            end_time: time_key,
            duration:((dt2-dt1)/60000),
            overlays:0,
            auto_accept_count:0
          })
        }
        dt1 = this.getTimestampFromDatetimeStr(time_key)
        dt2 = this.getTimestampFromDatetimeStr(res_map[time_key].end_time)
        this.cal_blocks.push({
          id:res_map[time_key].store_possible_reserve_time_id,
          start_time: time_key,
          end_time: res_map[time_key].end_time,
          duration:((dt2-dt1)/60000),
          overlays:res_map[time_key].overlays,
          auto_accept_count:res_map[time_key].auto_accept_count,
          is_highlight_start:is_highlight_start,
          is_highlighted:is_highlighted,
          is_highlight_end:is_highlight_end
        })
        prev_end_time = res_map[time_key].end_time
      }
      // 最後一個時段如果不是整點結束需補上最後一段到最後一小時結束的block
      if (this.getPartFromDatetimeStr(prev_end_time, 'minute') !== 0) {
        this.cal_blocks.push({
          id:0,
          start_time: prev_end_time,
          end_time: this.getPartFromDatetimeStr(last_key, 'datehour'),
          duration:(60-this.getPartFromDatetimeStr(prev_end_time, 'minute')),
          overlays:0,
          auto_accept_count:0
        })
      }
    }
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
    else {
      this.service_minute_unit = parseInt(this.$bus.session.store_service_rule.service_minute_unit)
    }
    if (this.$bus.linkCallStack.length) {
      this.fromParams = this.$bus.linkCallStack.pop().params
      this.fromStack = this.CpObj(this.$bus.linkCallStack)
      this.$bus.linkCallStack = []
    }
  },
  mounted () {
    if (this.fromStack && this.fromStack.length) {
      this.filterOptions[0].hide = false
    }
    this.$refs.filterForm.initDefault()
    if (this.fromParams) {
      // 由pass參數初始化的有指定日期與指定聚焦起訖時段兩種
      if (this.fromParams.open_date) {
        this.filterData.viewDate = this.fromParams.open_date
        this.$refs.filterForm.refreshModelVar('viewDate')
      }
      if (this.fromParams.highlight_from && this.fromParams.highlight_to) {
        this.highlight_from = this.fromParams.highlight_from
        this.highlight_to = this.fromParams.highlight_to
        this.filter_time = this.getPartFromDatetimeStr(this.highlight_from,'hourminute')
      }
    }
    if (this.filterData.viewDate) {
      this.get_date_data()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-small {
  font-size: x-small;
  padding-left: 0px;
  padding-right: 0px;
}

.rc-bar-view {
  float:left;
  height:70vh;
  overflow-y: scroll;
}
.rv-list-view {
  float:left;
  font-size: x-small;
  padding-left: 0px;
  padding-right: 0px;
  height:70vh;
  overflow-y: scroll;
}
</style>
